import React from 'react';

import { Box, Skeleton } from '@mui/material';
import RoundedBox from '@sharedCR/common/RoundedBox';
import PropTypes from 'prop-types';

import {
  getListTableSkeletonStyles,
  rowSkeletonStyles,
  tableBodySkeletonStyles,
} from './ListTableSkeleton.styles';

const defaultObject = {};

const ListTableSkeleton = ({
  rowsNumber,
  firstCellWidth = '270px',
  customStyles = defaultObject,
}) => (
  <RoundedBox customStyles={getListTableSkeletonStyles({ customStyles })} padding={24}>
    <Skeleton height={28} variant="rounded" width="250px" />
    <Box sx={tableBodySkeletonStyles}>
      {Array.from({ length: rowsNumber }, (_, index) => (
        <Box key={index} sx={rowSkeletonStyles}>
          <Skeleton height={24} variant="rounded" width={firstCellWidth} />
          <Skeleton height={24} variant="rounded" width="80px" />
        </Box>
      ))}
    </Box>
  </RoundedBox>
);

ListTableSkeleton.propTypes = {
  rowsNumber: PropTypes.number.isRequired,
  customStyles: PropTypes.object,
  firstCellWidth: PropTypes.string,
};

export default ListTableSkeleton;
